var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartsManOn = function SvgPartsManOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    d: "M12 22.214c0-2.206 1.794-4 4-4s4 1.794 4 4-1.794 4-4 4-4-1.795-4-4m4.571-5.107V6.831l4.547 4.547.808-.808L16 4.643l-5.926 5.927.808.808 4.547-4.547v10.276c-2.578.287-4.572 2.497-4.572 5.107A5.15 5.15 0 0 0 16 27.356a5.15 5.15 0 0 0 5.143-5.143c0-2.609-1.994-4.819-4.572-5.106M6.095 10.667a4.571 4.571 0 1 1 0-9.143 4.571 4.571 0 0 1 0 9.143"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.133 8.7 2.868 6.436l.68-.68L5.133 7.34l3.51-3.51.68.68z"
  }))));
};
export default SvgPartsManOn;